import { Card as AntdCard } from 'antd';
import { CardProps } from 'antd/es/card/Card';
import { PropsWithChildren } from 'react';

import { StyledCard } from '@atom/card/card.style';

export const Card = (props: PropsWithChildren<CardProps>) => <StyledCard {...props} />;

Card.Meta = AntdCard.Meta;
Card.Grid = AntdCard.Grid;
